export const FETCH_MAIN_AGREEMENT_LIST_REQUEST =
    'FETCH_MAIN_AGREEMENT_LIST_REQUEST';
export const FETCH_MAIN_AGREEMENT_LIST_SUCCESS =
    'FETCH_MAIN_AGREEMENT_LIST_SUCCESS';
export const FETCH_MAIN_AGREEMENT_LIST_FAILURE =
    'FETCH_MAIN_AGREEMENT_LIST_FAILURE';


export const DELETE_MAIN_AGREEMENT_REQUEST = 'DELETE_MAIN_AGREEMENT_REQUEST';
export const DELETE_MAIN_AGREEMENT_SUCCESS = 'DELETE_MAIN_AGREEMENT_SUCCESS';
export const DELETE_MAIN_AGREEMENT_FAILURE = 'DELETE_MAIN_AGREEMENT_FAILURE';
export const UPDATE_MAIN_AGREEMENT_REQUEST = 'UPDATE_MAIN_AGREEMENT_REQUEST';
export const UPDATE_MAIN_AGREEMENT_SUCCESS = 'UPDATE_MAIN_AGREEMENT_SUCCESS';
export const UPDATE_MAIN_AGREEMENT_FAILURE = 'UPDATE_MAIN_AGREEMENT_FAILURE';
export const CREATE_MAIN_AGREEMENT_REQUEST = 'CREATE_MAIN_AGREEMENT_REQUEST';
export const CREATE_MAIN_AGREEMENT_SUCCESS = 'CREATE_MAIN_AGREEMENT_SUCCESS';
export const CREATE_MAIN_AGREEMENT_FAILURE = 'CREATE_MAIN_AGREEMENT_FAILURE';


//Sub Agreement types
export const FETCH_SUB_AGREEMENT_LIST_REQUEST =
    'FETCH_SUB_AGREEMENT_LIST_REQUEST';
export const FETCH_SUB_AGREEMENT_LIST_SUCCESS =
    'FETCH_SUB_AGREEMENT_LIST_SUCCESS';
export const FETCH_SUB_AGREEMENT_LIST_FAILURE =
    'FETCH_SUB_AGREEMENT_LIST_FAILURE';


export const DELETE_SUB_AGREEMENT_REQUEST = 'DELETE_SUB_AGREEMENT_REQUEST';
export const DELETE_SUB_AGREEMENT_SUCCESS = 'DELETE_SUB_AGREEMENT_SUCCESS';
export const DELETE_SUB_AGREEMENT_FAILURE = 'DELETE_SUB_AGREEMENT_FAILURE';
export const UPDATE_SUB_AGREEMENT_REQUEST = 'UPDATE_SUB_AGREEMENT_REQUEST';
export const UPDATE_SUB_AGREEMENT_SUCCESS = 'UPDATE_SUB_AGREEMENT_SUCCESS';
export const UPDATE_SUB_AGREEMENT_FAILURE = 'UPDATE_SUB_AGREEMENT_FAILURE';
export const CREATE_SUB_AGREEMENT_REQUEST = 'CREATE_SUB_AGREEMENT_REQUEST';
export const CREATE_SUB_AGREEMENT_SUCCESS = 'CREATE_SUB_AGREEMENT_SUCCESS';
export const CREATE_SUB_AGREEMENT_FAILURE = 'CREATE_SUB_AGREEMENT_FAILURE';